if (!window.Eurus.loadedScript.includes("product-tabs.js")) {
  window.Eurus.loadedScript.push("product-tabs.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xProductTabs", () => ({
        open: 0,
        openMobile: false,
        tabActive: '',
        setTabActive() {

            const tabActive = this.$el.dataset.tabtitle;
            this.tabActive = tabActive;
        },
        initialize (){

            const url = new URL(window.location)

            setTimeout(() => {

                const isProductPage = ( url.pathname.includes(`/products/`) )

                const selector = ( isProductPage )
                    ? `:has( [ data-tab-type = 'Extra' ] ) > [ data-tab-type ]:not([ data-tab-type = 'Description' ]),[ data-tab-type ]`
                    : `[ data-tab-type ]:not([ data-tab-type = 'Extra' ]):not([ data-is-empty = 'true' ])`


                const tab = this.$el.querySelector(selector)

                if( tab )
                    this.open = tab.dataset.tabIndex
            })
        }
      }));
    });
  });
}
